export default {
    badges: {
        countryId: 'Država',
        cityId: 'Grad',
        filter: 'Pretraga',
        fromPrice: 'Cena od',
        toPrice: 'Cena do',
        serviceId: 'Potkategorija',
        serviceGroupId: 'Kategorija',
        orderBy: 'Sortiraj po',
        sort: {
            createdAt_ASC: 'Datumu rastuće',
            createdAt_DESC: 'Datumu opadajuće',
            distance_ASC: 'Po udaljenosti - Najbliže',
            priceRSD_ASC: 'Ceni rastuće',
            priceRSD_DESC: 'Ceni opadajuće',
            averageRating_ASC: 'Oceni rastuće',
            averageRating_DESC: 'Oceni opadajuće',
        },
    },
}
